import { LocationGroup } from "app/location-group/location-group.model";
import { Location } from "../../location/location.model";
import { countryCodes } from "../../shared/countries/country-codes.const";

export class QuoteLocation {
  constructor(
    private id: number = null,
    public location: Location = null,
    public inlandHaulage: string = null,
    public postalCode: string = null,
    public latitude: number = null,
    public longitude: number = null,
    public country: string = null,
    public locationGroup: LocationGroup = null,
  ) {}

  public getId(): number {
    return this.id;
  }

  public getLocation(): Location {
    return this.location;
  }

  public getCountry(): string {
    return this.country;
  }

  public getOfficialName(): string {
    return countryCodes[this.country] + " " + this.postalCode;
  }

  public getInlandHaulage(): string {
    return this.inlandHaulage;
  }

  public getPostalCode(): string {
    return this.postalCode;
  }

  public getLocationGroup(): LocationGroup {
    return this.locationGroup;
  }

  public getLatitude(): number {
    return this.latitude;
  }

  public getLongitude(): number {
    return this.longitude;
  }
}
